import theme from '../../muiTheme';
import { tooltipClasses } from '@mui/material/Tooltip';

console.log('theme: ', theme);

const styles = {


    homeContainer : {
      width: '100vw', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center', 
      background: '#f2f2f2', 
      position: 'relative', 
      paddingTop: '20px', 
      boxShadow: '0px -11px 1px 0px rgb(0 0 0 / 14%)',
      [theme.breakpoints.down('sm')]: {
        background: 'white', 
      }

    },

    rootContainer: {

      padding: '0px 0px 100px 0px !important',
      maxWidth: '67vw !important',
      [theme.breakpoints.down('xl')]: {
        maxWidth: '70vw !important',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100vw !important',
      }
    },
    appBarSearch: {
      borderRadius: 2,
      marginBottom: '1rem',
      display: 'flex',
      padding: '10px',
      marginBottom: '15px',
    },
    paginationContainer: {
      borderRadius: 4,
      marginTop: '1rem',
      padding: '16px',
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent'
    },
    gridContainer: {
      position: 'relative',
      background: '#f2f2f2',
      marginTop: '0px',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column-reverse',
        background: '#fff'
      }
    },
    searchButton: {
      width: '100%',
      // height: '40px',
      padding: '15px 10px',
      borderRadius: '50px',
      marginTop: '15px',
      backgroundColor: theme.palette.primary.main,
      color: 'white'
    },
    sideMenuItem: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '90px',
      //margin: '45px 25px',
      //width: '0px',
      cursor: 'pointer',
      color: theme.palette.gray,
      transition: '0.3s',
      '&:hover': {
        color: theme.palette.primary.main
      }
    },
    sideMenuIcon: {
      fontSize: '25px',
    },
    popUpOverlay: {
      backgroundColor: 'rgb(0 0 0 / 79%)',
      width: '100vw !important',
      height: '100vh !important',
      top: '0px',
      left: '0px',
      position: 'fixed !important',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: '1100'
    },
    formContainer: {
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '20px',
      maxWidth: '800px',
      zIndex: '1100',
      overflowY: 'scroll',
      overflowX: 'hidden',
      [theme.breakpoints.down('sm')]: {
        overflowX: 'hidden'
      }
    },
    formTitle: {
      margin: '30px 20px',
      marginBottom: '0px',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: '28px'
      }
    },
    formHeaderBar: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    formCancelButton: {
      margin: '0px',
      padding: '10px 10px',
      minWidth: '10px',
      [theme.breakpoints.down('sm')]: {
        padding: '15px 15px',
        minWidth: '10px',
        top: '15px',
        position: 'fixed',
        zIndex: 1,
        border: '3px solid white'
      }
    },
    queryTag: {
      padding: '5px 12px',
      margin: '3px 4px',
      borderRadius: '20px',
      transition: '0.3s',
      cursor: 'pointer',
      backgroundColor: theme.palette.faint,
      '&:hover, &:active, &:focus': {
        backgroundColor: theme.palette.primary.main,
        color: 'white'
      }
    }

}

export default styles; 